import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class CheckFindSnPhoneAuthCodeUsecase {
  constructor(private readonly userPasswordRepo: UserPasswordRepository) {}

  async execute(token: string, code: string): Promise<SATResult<string, SATError>> {
    return this.userPasswordRepo.checkFindSnPhoneAuthCode({
      token: token.trim(),
      code: code.trim(),
    });
  }
}
